import { InjectionToken } from '@angular/core';

export interface FeedbackEnvironment {
  publishableKey: string;
}

export const FeedbackEnvironmentToken = new InjectionToken<FeedbackEnvironment>('FeedbackEnvironmentToken');
